import styles from './reports.module.scss';
import { useState } from 'react';
import { Col, Row } from 'reactstrap';
import { Box, Container, Tab, Tabs } from '@frontend-workspace/react-shared-lib';
import PageTitle from '../../page-title/page-title';
import TotalReport from './total-report/total-report';
import EmailLog from './email-log/email-log';
import Search from './search/search';
import CourseReport from './course-report/course-report';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface ReportsProps { }

export function Reports(props: ReportsProps) {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState<number>(0);

  const navigateToTabOne = () => setSelectedTab(0);
  const navigateToTabTwo = () => setSelectedTab(1);
  const navigateToTabThree = () => setSelectedTab(2);
  const navigateToTabFour = () => setSelectedTab(3);

  return (
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component="div"
            className="pb-5">
            <PageTitle title={t("app.reports")} subtitle={`(${t("standard.admin")})`} />
            <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: '20px' }}>
              <Tabs
                value={selectedTab}
                variant="scrollable"
                scrollButtons="auto">
                <Tab label={t('reports.course')} onClick={navigateToTabOne} />
                <Tab label={t('reports.search')} onClick={navigateToTabTwo} />
                <Tab label={"Total"} onClick={navigateToTabThree} />
                <Tab label={t('reports.emailLog')} onClick={navigateToTabFour} />
              </Tabs>
            </Box>
            <div>
              {selectedTab === 0 && <CourseReport />}
              {selectedTab === 1 && <Search />}
              {selectedTab === 2 && <TotalReport />}
              {selectedTab === 3 && <EmailLog />}
            </div>
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default Reports;
